import Modal from "react-modal";
import { BsFiletypeCsv, BsFiletypeXlsx, BsDownload } from "react-icons/bs";
import styles from "./generateCSV.module.scss";

const GenerateCSV = (props) => {
    // `excel`: the export is a workbook (recommenders: two tabs), so the
    // dialog says Excel and lists the tabs instead of promising a CSV.
    const { title, isShowCSVModalVisible, handleCloseCSV, handleGenerateCSV, excel, excelTabs = [] } = props;

    const generateCSVPopupStyles = {
        content: {
            width: "90%",
            maxWidth: "420px",
            height: "auto",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            border: "none",
            borderRadius: "20px",
            padding: "0",
            background: "transparent",
            boxShadow: "none",
            outline: "none",
            overflow: "hidden",
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(8px)",
            zIndex: 1000,
        }
    };


    return (
        <Modal
            isOpen={isShowCSVModalVisible}
            onRequestClose={handleCloseCSV}
            style={generateCSVPopupStyles}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.icon}>
                        {excel ? <BsFiletypeXlsx /> : <BsFiletypeCsv />}
                    </div>
                    <h3 className={styles.title}>{`Export ${title} Data`}</h3>
                    <p className={styles.message}>
                        {excel
                            ? `Would you like to download your ${title} data as an Excel file?${excelTabs.length ? ` It has ${excelTabs.length} tabs — ${excelTabs.join(" and ")}.` : ""} It opens in Excel or Google Sheets.`
                            : `Would you like to download your ${title} data as a CSV file? This will include all ${title} details in a spreadsheet format that you can open in Excel or Google Sheets.`}
                    </p>
                </div>

                <div className="d-flex justify-content-center gap-3">
                    <button
                        className={styles.cancelButton}
                        onClick={handleCloseCSV}
                    >
                        Cancel
                    </button>
                    <button
                        className={styles.confirmButton}
                        onClick={handleGenerateCSV}
                    >
                        <BsDownload className={styles.downloadIcon} />
                        {excel ? "Export Excel" : "Export CSV"}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GenerateCSV;